document.addEventListener('DOMContentLoaded', function() {
    desktopBtn = document.querySelector('.load-more-btn-desktop');
    loadMorePostsBtn = document.querySelector('.load-more-posts-btn');
    loadMoreCommentsBtn = document.querySelector('.load-more-comments-btn'); 

    if( desktopBtn ) {
        // Desktop Load More Button
        desktopBtn.addEventListener('click', function() {
            let postIndex = parseInt(this.dataset.currentPostGroup) + 1;
            let commentIndex = parseInt(this.dataset.currentCommentGroup) + 1;
            let totalPostGroups = parseInt(this.dataset.totalPostGroups);
            let totalCommentGroups = parseInt(this.dataset.totalCommentGroups);

            // Show next group of posts
            if (postIndex <= totalPostGroups) {
                document.getElementById(`post-div-${postIndex}`).style.display = 'block';
                this.dataset.currentPostGroup = postIndex;
            }

            // Show next group of comments
            if (commentIndex <= totalCommentGroups) {
                document.getElementById(`comment-div-${commentIndex}`).style.display = 'block';
                this.dataset.currentCommentGroup = commentIndex;
            }

            // Hide button if no more posts or comments to show
            if (postIndex >= totalPostGroups && commentIndex >= totalCommentGroups) {
                this.style.display = 'none';
            }
        });
    }
    
    if ( loadMorePostsBtn ) {
        // Mobile Load More Posts Button
        loadMorePostsBtn.addEventListener('click', function() {
            let index = parseInt(this.dataset.currentPostGroup) + 1;
            let totalGroups = parseInt(this.dataset.totalPostGroups);

            if (index <= totalGroups) {
                document.getElementById(`post-div-${index}`).style.display = 'block';
                this.dataset.currentPostGroup = index;
            }

            if (index >= totalGroups) {
                this.style.display = 'none';
            }
        });
    }

    if ( loadMoreCommentsBtn ) {
        // Mobile Load More Comments Button
        loadMoreCommentsBtn.addEventListener('click', function() {
            let index = parseInt(this.dataset.currentCommentGroup) + 1;
            let totalGroups = parseInt(this.dataset.totalCommentGroups);

            if (index <= totalGroups) {
                document.getElementById(`comment-div-${index}`).style.display = 'block';
                this.dataset.currentCommentGroup = index;
            }

            if (index >= totalGroups) {
                this.style.display = 'none';
            }
        });
    }
});
